import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Alert // Import Alert for error display
} from '@mui/material';
import { toast } from 'react-toastify';
import { getFunctions, httpsCallable } from "firebase/functions"; // Import Firebase functions

const SupportModal = ({ open, onClose }) => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(''); // State for error messages

  const handleSubmit = async () => {
    if (!message.trim()) {
      toast.error('Please enter a message');
      return;
    }

    setLoading(true);
    setError(''); // Clear previous errors

    try {
      // --- FIX STARTS HERE ---
      const functions = getFunctions();
      const sendSupportRequest = httpsCallable(functions, 'sendSupportRequest');

      // Call the actual cloud function
      const result = await sendSupportRequest({ message: message.trim() });

      if (result.data.success) {
        toast.success('Support request sent successfully!');
        setMessage(''); // Clear message on success
        onClose();      // Close modal on success
      } else {
        // Handle cases where the function returns a non-success status
        throw new Error(result.data.message || 'An unknown error occurred.');
      }
      // --- FIX ENDS HERE ---

    } catch (error) {
      console.error("Error sending support request:", error);
      const errorMessage = error.message || 'Failed to send support request. Please try again.';
      setError(errorMessage); // Set specific error message for display
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // Close handler to also clear state
  const handleClose = () => {
    setMessage('');
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Contact Support</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Typography variant="body2" sx={{ mb: 2 }}>
          Describe your issue or question and our team will get back to you shortly.
        </Typography>
        <TextField
          autoFocus
          multiline
          rows={6}
          fullWidth
          label="Your message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          variant="outlined"
          placeholder="Please provide as much detail as possible..."
        />
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1 }}>
        <Button onClick={handleClose} sx={{ textTransform: 'none' }}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={loading}
          sx={{ textTransform: 'none' }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Send Request'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SupportModal;